/**
 * Whether a team member has no usable access level: none set, or one that no
 * longer exists. Such a member resolves to the most restrictive value of every
 * permission, so the Team Members list flags them for a manager.
 *
 * `levelCodes` is the list from /api/v1/access-levels/options; until it has
 * loaded (anything but an array) only an empty level is flagged.
 *
 * CommonJS so the node-backend logic tests can require it.
 */
function hasNoAccessLevel(value, levelCodes) {
    var code = String(value == null ? '' : value).trim().toLowerCase();
    if (code === '') return true;
    if (!Array.isArray(levelCodes)) return false;
    return levelCodes.indexOf(code) === -1;
}

module.exports = {
    hasNoAccessLevel: hasNoAccessLevel,
};
